module.exports = __webpack_public_path__ + "static/img/IMG_20170907_191935.c14c98da.jpg";